import { OptionData } from '@atlaskit/smart-user-picker';

import { User } from 'src/components/types';

// this file contains shared logic for the smart user picker component which is used by
// both the create pr page reviewer picker and pr page reviewer card

export const SmartUserPickerSharedProps = {
  isMulti: true,
  debounceTime: 400,
  fieldId: 'BitbucketPullRequestReviewers',
  maxOptions: 20,
  prefetch: false,
  isClearable: true,
  noBorder: true,
  principalId: 'Context',
  searchQueryFilter:
    'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)',
  siteId: 'bitbucket',
  productKey: 'bitbucket',
};

export const filterOptionsFunction = (
  isInputEmpty: boolean,
  recommendedReviewers: User[],
  currentUser: User,
  reviewersAccountIds?: any[],
  pendingAaids?: any[]
) => {
  return (options: OptionData[]) => {
    let recommendedReviewersList: any[] = [];
    // Gets reviewers from past PRs as recommendations for current PR and then filter out current reviewers and PR author
    if (
      isInputEmpty &&
      recommendedReviewers &&
      recommendedReviewers?.length > 0
    ) {
      recommendedReviewersList = recommendedReviewers.map((reviewer: User) => ({
        avatarUrl: reviewer.links.avatar.href,
        email: undefined,
        id: reviewer.account_id,
        lozenge: undefined,
        name: reviewer.display_name,
        type: 'user',
      }));
    }

    const recommendedReviewerIds = new Set();
    recommendedReviewersList.forEach((reviewer: { id: string }) => {
      recommendedReviewerIds.add(reviewer.id);
    });

    // filter out recommended reviewers from smart picker's list
    const filtered = options.filter(
      ({ id }) => !recommendedReviewerIds.has(id)
    );

    // check if existing reviewer is added again, probably not pending reviewers
    if (reviewersAccountIds && pendingAaids) {
      return [...recommendedReviewersList, ...filtered].filter(
        (reviewer: { id: string }) =>
          !reviewersAccountIds.includes(reviewer.id) &&
          currentUser?.account_id !== reviewer.id &&
          !pendingAaids.includes(reviewer.id)
      );
    } else {
      return [...recommendedReviewersList, ...filtered].filter(
        (reviewer: { id: string }) => currentUser?.account_id !== reviewer.id
      );
    }
  };
};
